import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Download, KeyRound } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/utt`;

export const AdminPartnerSettings = ({ adminKey }) => {
  const [s, setS] = useState(null);
  const [emails, setEmails] = useState('');
  const [newKey, setNewKey] = useState('');
  const [msg, setMsg] = useState('');
  const h = { headers: { 'X-Admin-Key': adminKey } };

  const load = useCallback(() => axios.get(`${API}/partner-settings`, { headers: { 'X-Admin-Key': adminKey } })
    .then((r) => { setS(r.data); setEmails(r.data.recipients.join(', ')); }).catch(() => {}), [adminKey]);
  useEffect(() => { if (adminKey) load(); }, [adminKey, load]);

  const downloadBatch = async () => {
    const r = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/admin/utt-applications/batch.xlsx`, { ...h, responseType: 'blob' }).catch(() => null);
    if (!r) return setMsg('Download failed');
    const url = URL.createObjectURL(r.data);
    const a = document.createElement('a');
    a.href = url; a.download = 'wekeza-utt-applications.xlsx'; a.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };

  const save = async () => {
    try {
      const recipients = emails.split(/[,\s]+/).map((e) => e.trim()).filter(Boolean);
      await axios.put(`${API}/partner-settings`, { recipients }, h);
      setMsg('Saved');
      load();
    } catch (e) { setMsg('Invalid email address'); }
  };
  const rotate = async () => {
    const r = await axios.post(`${API}/partner-key`, {}, h).catch(() => null);
    if (!r) { setMsg('Could not create key'); return; }
    setNewKey(r.data.partner_key);
    load();
  };
  if (!s) return null;
  return (
    <div className="mb-5 rounded-xl border border-slate-200 p-4" data-testid="admin-partner-settings">
      <p className="mb-2 text-sm font-semibold text-slate-900">Application hand-off to UTT AMIS / CORE</p>
      <label className="block text-xs text-slate-600">Send each new application (PDF + CSV) to:
        <div className="mt-1 flex gap-2">
          <input value={emails} onChange={(e) => setEmails(e.target.value)} placeholder="uwekezaji@uttamis.co.tz, onboarding@coresecurities.co.tz"
            className="flex-1 rounded-lg border border-slate-300 px-3 py-2 text-sm" data-testid="admin-partner-emails" />
          <button onClick={save} className="rounded-lg bg-slate-900 px-3 py-2 text-xs font-semibold text-white" data-testid="admin-partner-emails-save">Save</button>
        </div>
      </label>
      {msg && <p className="mt-1 text-xs text-slate-500" data-testid="admin-partner-msg">{msg}</p>}
      {s.default_inbox && <p className="mt-1 text-xs text-slate-500" data-testid="admin-partner-default-inbox">Always sent to UTT onboarding: <b>{s.default_inbox}</b></p>}
      {!s.recipients.length && !s.default_inbox && <p className="mt-1 text-xs text-amber-700">No recipients yet: applications are recorded but not emailed.</p>}
      <div className="mt-3 flex flex-wrap items-center gap-2 text-xs">
        <button onClick={downloadBatch} className="inline-flex items-center gap-1 rounded-lg border border-slate-300 px-3 py-1.5 font-semibold" data-testid="admin-utt-batch-download">
          <Download className="h-3.5 w-3.5" />Excel of unsent applications
        </button>
        <button onClick={rotate} className="inline-flex items-center gap-1 rounded-lg border border-slate-300 px-3 py-1.5 font-semibold" data-testid="admin-partner-key-rotate">
          <KeyRound className="h-3.5 w-3.5" />{s.has_partner_key ? 'Rotate partner key' : 'Create partner key'}
        </button>
        <a href="/partner-desk" target="_blank" rel="noreferrer" className="font-semibold text-emerald-700 underline" data-testid="admin-partner-desk-link">Open Partner Desk</a>
        {s.partner_key_rotated_at && <span className="text-slate-500">key set {new Date(s.partner_key_rotated_at).toLocaleDateString()}</span>}
      </div>
      {newKey && (
        <p className="mt-2 rounded-lg bg-amber-50 p-2 text-xs text-amber-800" data-testid="admin-partner-new-key">
          New partner key (shown once; share securely with UTT/CORE): <code className="select-all font-bold">{newKey}</code>
        </p>
      )}
    </div>
  );
};
